import React, { Component } from 'react';
import { RefreshCw } from 'lucide-react';
interface Props {
  children: React.ReactNode;
  sectionName: string;
  fallbackMinHeight?: string;
}
interface State {
  hasError: boolean;
}
export class SectionErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(_: Error): State {
    return {
      hasError: true
    };
  }
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error(`[Section "${this.props.sectionName}"] crashed:`, error, errorInfo);
  }
  handleRetry = () => {
    this.setState({
      hasError: false
    });
  };
  render() {
    if (this.state.hasError) {
      const minHeight = this.props.fallbackMinHeight || 'min-h-[200px]';
      return <div className={`flex flex-col items-center justify-center ${minHeight} bg-slate-50/50 rounded-xl border border-slate-100 p-6 m-4`} data-id="element-18656">
          <p className="text-sm text-slate-400 mb-3" data-id="element-18657">
            Секция временно недоступна
          </p>
          <button onClick={this.handleRetry} className="flex items-center gap-1.5 text-xs text-slate-400 hover:text-slate-600 transition-colors" aria-label="Обновить секцию" data-id="element-18658">
            <RefreshCw className="w-3.5 h-3.5" data-id="element-18659" />
            <span data-id="element-18660">Обновить</span>
          </button>
        </div>;
    }
    return this.props.children;
  }
}